/**
 * @generated SignedSource<<4861294ab293c5cef514b563cabf831f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentActionBarContent$data = {
  readonly entityId: string;
  readonly hasVideoContent?: boolean | null;
  readonly updatedDate: number | null;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentArticle">;
  readonly " $fragmentType": "contentActionBarContent";
};
export type contentActionBarContent$key = {
  readonly " $data"?: contentActionBarContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentActionBarContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentActionBarContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCommentArticle"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasVideoContent",
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "e32af718c4df2127d93c7feb9459b8ad";

export default node;
